import { Box, Breadcrumbs, Tab, Tabs, Stack, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import MainCard from './MainCard';
import { ListingActions } from 'store/slices/listings';
import { useDispatch, useSelector } from 'react-redux';
import ListingData from './Details/ListingData';
import SkeletonListing from './SkeletonListing';
import History from './Details/History';
import ImageUploadComponent from './Details/PhotosData';
import AccessData from './Details/AccessData';
import useAuth from 'hooks/useAuth';
import ListingAnalytics from './Details/ListingAnalytics';
import AnalyticsHistory from './Details/analyticsHistory';
import { IconEdit } from '@tabler/icons';
import { useNavigate } from 'react-router-dom';
import SyncDataWithAbor from './Details/SyncDataWithAbor';

const tabLabels = ['Listing', 'Photos', 'History', 'User Access to Listing'];
const tabLabelsAdmin = [
    'Listing',
    'Photos',
    'History',
    'User Access to Listing',
    'Listing Analytics',
    'Listing Analytics History',
    'Sync Data With Abor'
];

const ListingDetails = () => {
    const url = window.location.pathname;
    const id = url.substring(url.lastIndexOf('/') + 1);

    const { role, user } = useAuth();
    const dispatch = useDispatch();
    const { singleListing, loading } = useSelector((state) => state.listings);
    const { fetchListingDetails, fetchListingsAccessess } = ListingActions;

    const [listingAccessData, setListingAccessData] = useState([]);
    const [selectedTab, setSelectedTab] = useState(0);

    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            dispatch(fetchListingDetails(id));
            dispatch(fetchListingsAccessess(id)).then((e) => {
                setListingAccessData(e?.payload);
            });
        }
    }, [id]);

    const historyRefresh = () => {
        dispatch(fetchListingDetails(id));
    };

    return (
        <>
            <Breadcrumbs
                heading="View Listing"
                links={[
                    { name: 'Listings', href: '/listing/manage-listing' },
                    { name: 'Details', href: '/' }
                ]}
            />

            <MainCard
                title="Listings Details"
                headerSX={{
                    color: 'red'
                }}
                element={
                    <Stack direction="row" gap={3} flexWrap="wrap" justifyContent="flex-end" alignItems="center">
                        <Button
                            aria-label="Edit Listing"
                            sx={{ p: 2 }}
                            onClick={() => {
                                navigate(`/listing/${id}`);
                            }}
                        >
                            <IconEdit stroke={1.5} size="20px" />
                            Edit Listing
                        </Button>
                    </Stack>
                }
            >
                <Box sx={{ width: '100%', bgcolor: 'background.paper', mt: '-20px' }}>
                    <Tabs
                        value={selectedTab}
                        onChange={(e, newValue) => {
                            setSelectedTab(newValue);
                        }}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="scrollable auto tabs example"
                        TabIndicatorProps={{ style: { backgroundColor: 'black' } }}
                        sx={{
                            '& .MuiTabs-flexContainer': {
                                paddingLeft: 0,
                                marginLeft: 0
                            }
                        }}
                    >
                        {role === 'ADMIN'
                            ? tabLabelsAdmin?.map((label, index) => (
                                  <Tab
                                      key={index}
                                      label={label}
                                      sx={{
                                          minWidth: 'auto',
                                          paddingLeft: 1,
                                          paddingRight: 1
                                      }}
                                  />
                              ))
                            : tabLabels?.map((label, index) => (
                                  <Tab
                                      key={index}
                                      label={label}
                                      sx={{
                                          minWidth: 'auto',
                                          paddingLeft: 1,
                                          paddingRight: 1
                                      }}
                                  />
                              ))}
                    </Tabs>
                </Box>

                {loading ? (
                    <SkeletonListing />
                ) : (
                    <>
                        {selectedTab === 0 && <ListingData data={singleListing} propertyId={id} />}
                        {selectedTab === 1 && (
                            <ImageUploadComponent propertyId={id} data={singleListing?.attachments} historyRefresh={historyRefresh} />
                        )}
                        {selectedTab === 2 && <History data={singleListing?.history} extraData={singleListing} />}
                        {selectedTab === 3 && <AccessData data={listingAccessData} />}
                        {selectedTab === 4 && (
                            <ListingAnalytics
                                historyRefresh={historyRefresh}
                                hitCounters={singleListing?.hitCounters}
                                hitCountersCurrent={singleListing?.hitCountersCurrent}
                                propertyId={id}
                                isEdited={false}
                            />
                        )}
                        {selectedTab === 5 && (
                            <AnalyticsHistory historyRefresh={historyRefresh} data={singleListing?.hitCounters} propertyId={id} />
                        )}
                        {selectedTab === 6 && (
                            <SyncDataWithAbor
                                data={singleListing?.lasySyncedWithMLS}
                                propertyId={id}
                                listingId={singleListing?.listing_id}
                            />
                        )}
                    </>
                )}
            </MainCard>
        </>
    );
};

export default ListingDetails;
